import { render, staticRenderFns } from "./CellBoolean.vue?vue&type=template&id=d654d030"
import script from "./CellBoolean.vue?vue&type=script&lang=js"
export * from "./CellBoolean.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports